<template>
  <div>
    <a-card style="border: none;border-radius: 12px;margin-bottom: 20px;">
      <a-form layout="inline">
        <a-form-item>
          <a-input v-model="dataForm.name" placeholder="名称">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button @click="getDataList" type="primary">
            搜索
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="addOrUpdateHandle()">
            新增
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card style="border: none;border-radius: 12px;" title="菜单管理">
      <div slot="extra">
        <a-button icon="redo" @click="getDataList">
          刷新数据
        </a-button>
      </div>
      <a-table rowKey="id" :columns="columns" :data-source="dataList" :pagination="false" :loading="dataListLoading"
        >
        <span slot="type" slot-scope="text">
          <a-tag color="green" v-if="text == 1">
            菜单
          </a-tag>
          <a-tag color="blue" v-if="text == 2">
            按钮
          </a-tag>
        </span>
        <span slot="icon" slot-scope="text">
          <svg-icon v-if="text" :iconClass="text ? text : ''" color="#000" />
        </span>
        <span slot="action" slot-scope="text, record">
          <a-space>
            <a-button type="link" @click="addOrUpdateHandle(record.id)">编辑 </a-button>
            <a-button type="link" @click="deleteHandle(record.id)">删除</a-button>
          </a-space>
        </span>
      </a-table>
    </a-card>
    <addOrUpdate ref="addOrUpdate" @ok="getDataList"></addOrUpdate>
  </div>
</template>

<script>
import viewModule from '@/mixins/view-module'
import addOrUpdate from './components/menuaddorupdate.vue'
export default {
  mixins: [viewModule],
  components: { addOrUpdate },
  data() {
    return {
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'id',
        //   key: 'id',
        //   align: 'center'
        // },
        {
          title: '名称',
          dataIndex: 'title',
          key: 'title',
          align: 'left',
          width: 200
        },
        {
          title: '页面命名',
          align: 'center',
          key: 'name',
          dataIndex: 'name',
        },
        {
          title: '图标',
          align: 'center',
          key: 'icon',
          dataIndex: 'icon',
          scopedSlots: { customRender: 'icon' },
        },
        {
          title: '路由',
          align: 'center',
          key: 'path',
          dataIndex: 'path',
        },
        {
          title: '文件路径',
          align: 'center',
          key: 'component',
          dataIndex: 'component',
        },
        {
          title: '权限标识',
          align: 'center',
          key: 'power',
          dataIndex: 'power',
        },
        {
          title: '类型',
          align: 'center',
          key: 'type',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '排序',
          align: 'center',
          key: 'sort',
          dataIndex: 'sort',
        },
        {
          title: '操作',
          key: 'action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      mixinViewModuleOptions: {
        getDataListURL: '/menu/page',
        deleteURL: '/menu/delete',
        getDataListIsPage: false
      },
      dataForm: {
        name: ''
      }
    };
  },
  methods: {

  }
}
</script>

<style></style>